import { useEffect, useRef } from "react";
import {
    Pencil,
    Copy,
    Pin,
    PinOff,
    Star,
    StarOff,
    Trash2
} from "lucide-react";

export default function MediaListMenu({

    open,
    anchor,
    list,
    onClose,
    onRename,
    onDuplicate,
    onPin,
    onFavorite,
    onDelete

}) {

    const ref = useRef();
const MENU_WIDTH = 240;
const MENU_HEIGHT = 270;

const left = Math.min(
    anchor?.x + 50,
    window.innerWidth - MENU_WIDTH - 12
);

const top = Math.min(
    anchor?.y- 80,
    window.innerHeight - MENU_HEIGHT - 12
);
    useEffect(() => {

        function handleClick(e) {

            if (
                ref.current &&
                !ref.current.contains(e.target)
            ) {
                onClose?.();
            }

        }

        document.addEventListener(
            "mousedown",
            handleClick
        );

        return () =>
            document.removeEventListener(
                "mousedown",
                handleClick
            );

    }, []);

    if (!open || !anchor) {
        return null;
    }

    return (

        <div

            ref={ref}

            className="media-list-menu"

            style={{

    top,

    left

}}

        >

            <button
                onClick={() => {
                    onRename?.(list);
                    onClose();
                }}
            >

                <Pencil size={17} />
                <span>Rename</span>

            </button>

            <button
                onClick={() => {
                    onDuplicate?.(list);
                    onClose();
                }}
            >

                <Copy size={17} />
                <span>Duplicate</span>

            </button>

            <div className="menu-divider" />

            <button
                onClick={() => {
                    onPin?.(list);
                    onClose();
                }}
            >

                {
                    list?.pinned
                        ? <PinOff size={17} />
                        : <Pin size={17} />
                }

                <span>

                    {
                        list?.pinned
                            ? "Unpin"
                            : "Pin"
                    }

                </span>

            </button>

            <button
                onClick={() => {
                    onFavorite?.(list);
                    onClose();
                }}
            >

                {
                    list?.favorite
                        ? <StarOff size={17} />
                        : <Star size={17} />
                }

                <span>

                    {
                        list?.favorite
                            ? "Remove Favorite"
                            : "Favorite"
                    }

                </span>

            </button>

            <div className="menu-divider" />

            <button

                className="danger"

                onClick={() => {
                    onDelete?.(list);
                    onClose();
                }}

            >

                <Trash2 size={17} />
                <span>Delete</span>

            </button>

            <style>{`

.media-list-menu{

    position:fixed;
    width:140px;

    background:rgba(255,255,255,.96);
    backdrop-filter:blur(18px);

    border:1px solid rgba(229,231,235,.9);

    border-radius:16px;

    overflow:hidden;

   box-shadow:

0 20px 45px rgba(15,23,42,.15);


   animation:menuFade .18s cubic-bezier(.22,1,.36,1);
    z-index:9999;

}

@keyframes menuFade{

from{

opacity:0;

transform:
translateY(-8px)
scale(.96);

}

to{

opacity:1;

transform:
translateY(0)
scale(1);

}

}

.media-list-menu button{

    width:100%;

    height:46px;

    border:none;

    background:transparent;

    cursor:pointer;

    display:flex;

    align-items:center;

    gap:12px;

    padding:0 16px;

    color:#334155;

    font-size:14px;

    font-weight:500;

    border-radius:10px;

    margin:4px;

    width:calc(100% - 8px);
    transition:
        background .18s,
        color .18s;

}

.media-list-menu button svg{

    flex-shrink:0;

    color:#64748B;

    transition:.18s;

}

.media-list-menu button:hover{

    background:#F8FAFC;

}

.media-list-menu button:hover svg{

    color:#2563EB;

}

.media-list-menu button span{

    flex:1;

    text-align:left;

}

.menu-divider{

    height:1px;

    background:#EEF2F7;

    margin:6px 12px;

}

.media-list-menu .danger{

    color:#DC2626;

}

.media-list-menu .danger svg{

    color:#DC2626;

}

.media-list-menu .danger:hover{

    background:#FEF2F2;

}
@media(max-width:640px){

.media-list-menu{

    width:190px;


}

}@media(max-width:992px){

.media-list-menu{

    width:180px;

}

.media-list-menu button{

    height:48px;

}

}
@media(max-width:480px){

.media-list-menu{

    left:70px !important;

    right:10px;

    width:180px;

}

.media-list-menu button{

    height:50px;

    font-size:15px;

}

}
`}</style>

        </div>

    );

}